// extracted by mini-css-extract-plugin
export default {"span4":"customer_span4__14kwk","span5":"customer_span5__+e2FK"};